module.exports = __webpack_public_path__ + "img/logotipo.52293e92.svg";